import useAuth from "src/hooks/useAuth";
import useSettings from "src/hooks/useSettings";
import { getPlan } from "src/utils/plan";
import { isSummusCode0 } from "src/utils/restrictedAccess";
import { PATH_PAGE } from "src/routes/paths";
import Horizontal from "./components/horizontal";
import Vertical from "./components/vertical";
import navConfig from "./navConfig";
import SupportFab from "src/components/Support/SupportFab";
import { Typography } from "@mui/material";

// Appended to the bottom of every menu (user and admin, all plan flavors) so the
// public Terms of Service page is always reachable from inside the platform.
const LEGAL_NAV_GROUP = {
  items: [
    {
      title: "termsOfService",
      path: PATH_PAGE.termsOfService,
      icon: "/icons/ic_invoice.svg",
    },
  ],
};

const Layout = () => {
  const flavor = getPlan();
  const { isAdmin } = useAuth();

  // Voci con `restrictedTo: "summuscode0"` visibili solo a summuscode0 (gate
  // temporaneo, per pagine in attesa di approvazione). isSummusCode0 legge l'id
  // dal JWT (sub=710). Vale per OGNI flavor (UNILEVEL e' l'attivo in prod).
  const allowRestricted = isSummusCode0();
  const canSee = (item) => !item?.restrictedTo || allowRestricted;
  const filterGroups = (groups) =>
    groups
      .map((g) => ({ ...g, items: (g.items || []).filter(canSee) }))
      .filter((g) => (g.items || []).length > 0);

  const config = filterGroups([
    ...navConfig[flavor][isAdmin ? "admin" : "user"],
    LEGAL_NAV_GROUP,
  ]);

  const { themeLayout } = useSettings();
  const verticalLayout = themeLayout === "vertical";
  // SupportFab qui (e non in App.js) così Jinkō copre area utente e admin in
  // entrambe le varianti di layout, senza toccare pagine pubbliche e /hub.
  return (
    <>
      {verticalLayout ? (
        <Vertical navConfig={config} />
      ) : (
        <Horizontal navConfig={config} />
      )}
      <SupportFab />
    </>
  );
};
export default Layout;
